export default __webpack_public_path__ + "static/media/magician.442029f5.png";